import React, {useMemo, useState} from "react";
import {Row, FormControl, InputGroup} from "react-bootstrap";
import debounce from "lodash/debounce";
import {queryStringToHash, updateQueryString} from "./lib/utils";
import {useUpdateEffect} from './lib/customHooks';

const style = Object.freeze({maxWidth: 200});

export const rejectEmptyValue = obj =>
  Object.keys(obj)
    .filter(k => obj[k] !== undefined)
    .reduce((acc, k) => ({...acc, [k]: obj[k]}), {});

const defaultIndex = (list, order, direction, includeBlank) => {
  const idx = list.findIndex(row => (row.order === order) && (row.direction === direction));
  const defaultValue = includeBlank ? -1 : 0;
  return idx === -1 ? defaultValue : idx;
};

const order_key = 'order[]';
const direction_key = 'direction[]';

const SearchOrder = props => {
  const list = useMemo(() => JSON.parse(props.list), [props.list]);
  const [index, setIndex] = useState(defaultIndex(list, props.order, props.direction, props.includeBlank));
  const [jqxhr, setJqxhr] = useState(null);

  const fetch = debounce((q) => {
    if (jqxhr) {
      jqxhr.abort();
    }

    updateQueryString(rejectEmptyValue(q));

    const options = {
      type: 'GET',
      url: props.url,
      data: {...queryStringToHash(), ...q}
    };
    setJqxhr($.ajax(options));
  }, 500);

  const handleChange = e => {
    e.persist();
    setIndex(e.target.value);
  };

  useUpdateEffect(() => {
    const orgParams = queryStringToHash();
    const params = {
      order: Object.assign(Array(props.nth - 0), orgParams['order'] || []),
      direction: Object.assign(Array(props.nth - 0), orgParams['direction'] || []),
    };

    params.order[props.nth - 1] = list[index]?.order;
    params.direction[props.nth - 1] = list[index]?.direction

    fetch(params);
  }, [index]);

  return (
    <InputGroup className="align-items-center">
      <InputGroup.Text>{props.label}</InputGroup.Text>
      <FormControl
        as="select"
        style={style}
        value={index}
        onChange={handleChange} >
        {props.includeBlank && <option value="-1">未選択</option>}
        {list.map((row, idx) =>
          <option key={idx} value={idx}>{row.label}</option>
        )}
      </FormControl>
    </InputGroup>
  );
}

export default SearchOrder;
